import type { QueryHookOptions } from "@apollo/client";
/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
import { gql, useQuery } from "@apollo/client";

const WordpressSpecials_Emerson_Query = gql`
  query WordpressSpecials_Emerson_Query {
    specials(where: { orderby: { field: DISPLAYORDER_SPECIALS, order: ASC } }) {
      nodes {
        specialActionUrl
        specialBrandImage
        specialText
        specialPromoCode
        specialDisplayOrder
      }
    }
  }
`;

export type WordpressSpecialType = {
  specialActionUrl: string;
  specialBrandImage: string;
  specialText: string;
  specialPromoCode: string;
  specialDisplayOrder: number;
};

export type WordpressSpecialsResults = {
  specials?: {
    nodes?: WordpressSpecialType[];
  };
};

const useWordpressSpecialsQuery = (options?: QueryHookOptions<WordpressSpecialsResults>) =>
  useQuery<WordpressSpecialsResults>(WordpressSpecials_Emerson_Query, {
    context: { clientName: "wordpress" },
    ...options,
  });

export { useWordpressSpecialsQuery, WordpressSpecials_Emerson_Query };
